









































import {Component, Mixins, Prop } from 'vue-property-decorator';
import JdhModalDialog from "@/design-system/shared/JdhModalDialog.vue"
import UniqueIdMixin from "@/design-system/utilities/UniqueIdMixin"
import AnalyticsEmitterMixin
    from "@/design-system/foundation/AnalyticsProvider/AnalyticsEmitterMixin"
import { JdsError } from '@/design-system/utilities/JdsError';

/**
 * @status stable
 * @published 5.2.0
 * @changelog 5.2.0 Published.
 * @typed
 *
 * @analytics jds.explorer:cancel Fired on user-initiated explorer canceling.
 * @analyticsParam jds.explorer:cancel trigger Either `backdrop` or `button`, which the user clicked on to cancel this explorer. Backdrop also includes the escape key.
 * @analyticsParam jds.explorer:cancel duration How long, in milliseconds, the explorer stayed open.
 */
@Component({
    components: {JdhModalDialog}
})
export default class JdsExplorer extends Mixins(UniqueIdMixin, AnalyticsEmitterMixin) {
    @Prop() icon!: string;

    state = false
    openedAtTimestamp: number = Date.now();
    protected onConfirm?: (a: UIEvent) => any;
    protected onCancel?: (a: UIEvent) => any;


    /**
     * Open this explorer.
     *
     * @public
     */
    open() {
        this.state = true
        this.openedAtTimestamp = Date.now()

        return new Promise<UIEvent>((res, err) => {
            this.onConfirm = res;
            this.onCancel = () => {
                err(new JdsError('Explorer cancelled', (this.$options.name as string), 'cancel'));
            };
        });
    }

    /**
     * Close this explorer, after executing its function.
     *
     * @public
     */
    close() {
        this.state = false
    }

    cancelViaBackdrop() {
        this.$analytics('jds.explorer:cancel', { trigger: 'backdrop', duration: Date.now() - this.openedAtTimestamp })
        this.cancel()
    }

    cancelViaButton() {
        this.$analytics('jds.explorer:cancel', { trigger: 'button', duration: Date.now() - this.openedAtTimestamp  })
        this.cancel()
    }

    /**
     * Cancel this explorer, marking it as incomplete.
     *
     * @public
     */
    cancel() {
        this.state = false
    }
}
